import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { SkeletonBlock } from "./SkeletonBlock.jsx";

export function ReportBuilderRouteSkeleton() {
  const { c, dark } = useThemeSlice();
  const cardLift = dark ? "0 20px 42px rgba(0,0,0,.34)" : "0 16px 36px rgba(15,23,42,.10)";

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden", padding: 14 }}>
      <div
        style={{
          background: c.card,
          border: `1px solid ${c.cardBdr}`,
          borderRadius: 12,
          flex: 1,
          minHeight: 0,
          padding: 16,
          boxShadow: cardLift,
          display: "flex",
          flexDirection: "column",
          gap: 14,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <SkeletonBlock width={100} height={10} style={{ marginBottom: 8 }} />
            <SkeletonBlock width={180} height={18} style={{ marginBottom: 8 }} />
            <SkeletonBlock width={280} height={12} />
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <SkeletonBlock width={80} height={36} radius={8} />
            <SkeletonBlock width={100} height={36} radius={8} />
          </div>
        </div>
        <SkeletonBlock width="100%" height={32} radius={8} />
        <div style={{ display: "flex", gap: 14, flex: 1, minHeight: 0 }}>
          <SkeletonBlock width="100%" height="100%" radius={10} style={{ flex: 1 }} />
          <SkeletonBlock width={300} height="100%" radius={12} />
        </div>
      </div>
    </div>
  );
}
